import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { SuperAdminAuthContext } from "../../../contexts/SuperAdminAuthContext";

export default function SuperAdminProtectedRoute() {
  const { admin, adminLoading, adminSessionChecked } = useContext(SuperAdminAuthContext);
  const location = useLocation();

  if (!adminSessionChecked || adminLoading) return <div style={{ padding: 20 }}>Loading...</div>;

  if (!admin) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
